import React from "react";
import { useState } from "react";
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import logo from "../assets/logo.png";
import us from "../assets/us.png";
import 'bootstrap/dist/css/bootstrap.min.css';

let Header = ({clickPopup}) => {

    return (
        <header>
            <Navbar expand="lg">
                <Container fluid="lg">
                    <Navbar.Brand href="./">
                        <img src={logo} alt="logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarSupportedContent" />
                    
                    <Navbar.Collapse id="navbarSupportedContent">
                        <Nav className="me-auto mb-2 mb-lg-0">
                            <Nav.Link href="/" active>Main</Nav.Link>
                            <Nav.Link href="/about">About us</Nav.Link>
                            <Nav.Link href="/models">Our cases</Nav.Link>
                            <Nav.Link href="/blog">Our Blog</Nav.Link>
                            <Nav.Link href="/contacts">Contacts</Nav.Link>
                        </Nav>
                        <Nav className="switchers">
                            <Nav.Item>
                                <Nav.Link href="/us"><img src={us} alt="US" /></Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="button-wrapper">
                            <button className="main-button" onClick={clickPopup}>
                                Enroll now
                            </button>
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
}

export default Header;